import { render, staticRenderFns } from "./WsCreateBatchFromParagraph.vue?vue&type=template&id=02c1abdd&scoped=true&"
import script from "./WsCreateBatchFromParagraph.vue?vue&type=script&lang=js&"
export * from "./WsCreateBatchFromParagraph.vue?vue&type=script&lang=js&"
import style0 from "./WsCreateBatchFromParagraph.vue?vue&type=style&index=0&id=02c1abdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c1abdd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VCol,VDivider,VRow,VSkeletonLoader,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep})
